module.exports = __webpack_public_path__ + "static/media/IELTS_process.71ac7bad.png";